import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private constant: Constant) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    this.httpOptions.headers = headers;
  }

  // Get department list
  getDepartment(): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/department', this.httpOptions);
  }

  // Get department by id
  getDepartmentById(id): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/department/' + id, this.httpOptions);
  }

  // Update department by id
  updateDepartment(id, department): Observable<any> {
    return this.http.put<any>(this.constant.API_ENDPOINT + '/department/' + id, JSON.stringify(department),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Add department
  addDepartment(department): Observable<any> {
    return this.http.post<any>(this.constant.API_ENDPOINT + '/department', JSON.stringify(department),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Delete department by id
  deleteDepartment(id): Observable<any> {
    return this.http.patch<any>(this.constant.API_ENDPOINT + '/department/' + id, {},
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  // Get department list
  getDepartmentByCompanyId(companyId): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/department/company/'+companyId);
  }

  // Error handling
  handleError(error) {
  console.log(error);
  let errorMessage = '';
  if(error.error && error.error.data) {
    errorMessage = error.error.data.error_message;
  }
  return throwError(errorMessage);
  }
}